export const menuPlanContainer = (theme) => ({
  display: "grid",
  // For screens below `md`, show a single column (stack).
  // For `md` and up, create 7 columns side by side (assuming 7 days).
  gridTemplateColumns: {
    xs: "1fr",
    md: "repeat(7, 1fr)",
  },
  gap: theme.spacing(2),
  width: "100%",
});

export const dayCard = (theme) => ({
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[2],
  height: "fit-content", // Allow card to grow with content
});

export const cardContent = (theme) => ({
  padding: theme.spacing(1.5, 1),
});

export const mealBox = (theme) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  borderRadius: "0.5rem",
  backgroundColor: theme.palette.background.subtle,
  marginBottom: theme.spacing(2),
  padding: theme.spacing(0.75, 1),
  overflow: "hidden",
  cursor: "pointer",
  minHeight: "fit-content",
  width: "100%",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
});

export const mealHeader = (theme) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  marginBottom: theme.spacing(1),
});

export const mealHeaderText = (theme) => ({
  fontWeight: "bold",
  color: theme.palette.text.primary,
  fontSize: "0.8rem",
});

export const removeButton = (theme) => ({
  color: theme.palette.error.main,
  padding: theme.spacing(0.5),
  "&:hover": {
    backgroundColor: theme.palette.error.lighter,
  },
});

export const mealContentBox = (theme) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  width: "100%",
});

export const recipeItemBox = (theme, isLastItem) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  marginBottom: isLastItem ? 0 : theme.spacing(1),
});

export const mealContentText = (theme, recipeExists) => ({
  fontSize: "0.8rem",
  fontStyle: recipeExists ? "normal" : "italic",
  color: theme.palette.text.secondary,
  overflow: "hidden",
  textOverflow: "ellipsis",
  wordBreak: "break-word",
});
